 // const getIPAddress = async (): Promise<string> => {
//     try {
//       const response = await fetch("https://api.ipify.org?format=json");
//       const data = await response.json();
//       return data.ip;
//     } catch (error) {
//       console.error("Failed to get IP address", error);
//       return "Unavailable";
//     }
//   };
  
export const getUserInfo = async (): Promise<string> => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error("Failed to get user info", error);
      return "Unavailable";
    }
  };
